var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedinRound = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7H7.46875C6.9375 7 6.5 7.46875 6.5 8.03125V20C6.5 20.5625 6.9375 21 7.46875 21H19.5C20.0312 21 20.5 20.5625 20.5 20V8.03125C20.5 7.46875 20.0312 7 19.5 7ZM10.7188 19H8.65625V12.3438H10.7188V19ZM9.6875 11.4062C9 11.4062 8.46875 10.875 8.46875 10.2188C8.46875 9.5625 9 9 9.6875 9C10.3438 9 10.875 9.5625 10.875 10.2188C10.875 10.875 10.3438 11.4062 9.6875 11.4062ZM18.5 19H16.4062V15.75C16.4062 15 16.4062 14 15.3438 14C14.25 14 14.0938 14.8438 14.0938 15.7188V19H12.0312V12.3438H14V13.25H14.0312C14.3125 12.7188 15 12.1562 16 12.1562C18.0938 12.1562 18.5 13.5625 18.5 15.3438V19Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13,
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedinRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin-round.1a4f281730e17bf4cd2f1f85c41fc42a.svg";